<template>
    <section class="section-wrapp">
        <RestrictionsHistoryTable></RestrictionsHistoryTable>
    </section>
</template>

<script>
import RestrictionsHistoryTable from '@/components/stations/RestrictionsHistoryTable.vue'

export default {
  name: 'RestrictionsHistory',
  components: {
    RestrictionsHistoryTable
  },
  data () {
    return {
      message: ''
    }
  },
  computed: {

  },
  methods: {
    showRestrictions () {
      console.log(this.restrictions())
    }
  }
}
</script>
